<template>
  <div
    class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
  >
    <!--
    Background overlay, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0"
      To: "opacity-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100"
      To: "opacity-0"
  -->
    <div class="fixed inset-0 transition-opacity">
      <div class="absolute inset-0 bg-gray-500 opacity-75" @click="close"></div>
    </div>

    <!--
    Modal panel, show/hide based on modal state.

    Entering: "ease-out duration-300"
      From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
      To: "opacity-100 translate-y-0 sm:scale-100"
    Leaving: "ease-in duration-200"
      From: "opacity-100 translate-y-0 sm:scale-100"
      To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
  -->
    <div
      class="relative bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-3xl sm:w-full sm:p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-headline"
    >
      <div class="sm:flex sm:items-start">
        <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
          <h3
            class="text-lg leading-6 font-medium text-gray-900"
            id="modal-headline"
          >
            Step {{ currentStep }} of {{ steps.length }}
          </h3>
          <div class="mt-2">
            <div
              class="text-sm"
              v-html="steps[currentStep - 1].topContent"
            ></div>
            <img class="mt-5" :src="steps[currentStep - 1].image" />
            <div
              class="mt-5 text-sm"
              v-html="steps[currentStep - 1].bottomContent"
            ></div>
          </div>
        </div>
      </div>
      <div class="sm:ml-4 mt-4">
        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button
              class="Polaris-Button Polaris-Button--primary"
              v-if="currentStep != steps.length"
              type="button"
              @click="nextStep"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Next</span>
              </span>
            </button>
          </span>
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button
              v-if="currentStep === steps.length"
              class="Polaris-Button Polaris-Button--primary"
              type="button"
              @click="completedSteps"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text"
                  >I have completed all the steps</span
                >
              </span>
            </button>
          </span>
          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button
              class="Polaris-Button Polaris-Button--primary"
              v-if="currentStep != 1"
              type="button"
              @click="previousStep"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text">Back</span>
              </span>
            </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OptinOnboardingModal",
  data() {
    return {
      currentStep: null,
      steps: []
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      const store = this.$store.getters.getStore;
      this.steps = [
        {
          topContent: `Open your store's <a class="text-blue-700" href="https://${store.shopOrigin}/admin/settings/checkout" target="blank"><b> Shopify admin > Checkout settings </b></a>
     page.<br/><br/>

Search for Customer contact section, and select the option that allows customers to checkout using "phone number or email", as shown in the screenshot below:`,
          image: "https://configs.carthike.com/images/optinonboarding1.png",
          bottomContent:
            "If you need to select the email-only option, it's ok. Make sure to complete Step 2."
        },
        {
          topContent:
            "Search for <b>Form options</b> section on the same page.<br/> Set <b>Shipping address phone number</b> as Required or Optional.",
          image: "https://configs.carthike.com/images/optinonboarding2.png",
          bottomContent:
            "We recommend setting it to Required if you selected email-only option in Step 1. Otherwise, we won't get the customer's phone number to send WhatsApp message."
        },
        {
          topContent:
            "Search for <b>Email Marketing</b> section on the same page. Select both the checkboxes as shown in the screenshot below:",
          image: "https://configs.carthike.com/images/optinonboarding3.png",
          bottomContent:
            "Selecting this checkbox helps you get maximum possible opt-ins from the Checkout page."
        },
        {
          topContent: `Click on <b>Customize label</b> as shown in the screenshot below.`,
          image: "https://configs.carthike.com/images/optinonboarding4.png",
          bottomContent: ""
        },
        {
          topContent:
            "In the <b>Manage checkout language</b> page, search for <b>checkbox</b> as shown in the screenshot below:",
          image: "https://configs.carthike.com/images/optinonboarding5.png",
          bottomContent: `Update the text field shown above to ANY of the following options:
<ul class="list-disc">
<li>Get order updates on WhatsApp</li>
<li>Sign up for order updates, exclusive offers and news on WhatsApp and/or Email</li>
</ul>
Mention other channels like SMS or Email if you are using them. For example - "Get order updates on WhatsApp and/or SMS".`
        },
        {
          topContent:
            "On the same page, search for <b>Phone</b> or <b>Optional phone</b> as shown in the screenshot below:",
          image: "https://configs.carthike.com/images/optinonboarding6.png",
          bottomContent: `Update the text field shown above to:

Phone number for order updates
This will help inform your customers about how their phone number will be used.`
        },
        {
          topContent:
            "That was the final change required. Click the <b>Save</b> button on the top-right corner of the page to save all your changes.",
          image: "https://configs.carthike.com/images/optinonboarding7.png",
          bottomContent: ""
        }
      ];
      this.currentStep = 1;
    },
    close() {
      this.$emit("close");
    },
    nextStep() {
      this.currentStep = this.currentStep + 1;
    },
    previousStep() {
      this.currentStep = this.currentStep - 1;
    },
    completedSteps() {
      this.$store.dispatch("completedOptinSteps").then(() => {
        this.$emit("close");
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
